export const FETCH_ALL_SCORE_CLASSROOM_REQUEST = "gradeReducer/FETCH_ALL_SCORE_CLASSROOM_REQUEST";
export const FETCH_ALL_SCORE_CLASSROOM_SUCCESS = "gradeReducer/FETCH_ALL_SCORE_CLASSROOM_SUCCESS";
export const FETCH_ALL_SCORE_CLASSROOM_FAILED = "gradeReducer/FETCH_ALL_SCORE_CLASSROOM_FAILED";

export const FETCH_ALL_SCORE_USER_REQUEST = "gradeReducer/FETCH_ALL_SCORE_USER_REQUEST";
export const FETCH_ALL_SCORE_USER_SUCCESS = "gradeReducer/FETCH_ALL_SCORE_USER_SUCCESS";
export const FETCH_ALL_SCORE_USER_FAILED = "gradeReducer/FETCH_ALL_SCORE_USER_FAILED";